module.exports = __webpack_public_path__ + "img/Competition Winners.29a3ef57.png";